import React from 'react';
import { bool, string, func } from 'prop-types';
import IconArrowDown from './icons/IconArrowDown';
import IconArrowUp from './icons/IconArrowUp';

const TableHeaderButton = ({
  label,
  isDisabled,
  sortOrder,
  sortBy,
  isActive,
  onClick,
}) => {
  return (
    <button
      type="button"
      className="de--table__col--root"
      disabled={isDisabled}
      onClick={() => onClick(label, sortBy)}
    >
      <span>{label}</span>
      <span className="de--sort__icon de--sort__icon--down">
        {isActive && sortOrder === 'desc' && <IconArrowDown />}
        {isActive && sortOrder === 'asc' && <IconArrowUp />}
      </span>
    </button>
  );
};

TableHeaderButton.propTypes = {
  label: string,
  isDisabled: bool,
  sortOrder: string,
  sortBy: string,
  onClick: func,
  isActive: bool,
};

export default TableHeaderButton;
